import _ from '../helper/HelperFunctions';

export default class TOC {
	constructor(array) {
		this.items = array;
		this.container = document.querySelector('.vl-toc ul');
		this.items;
		this.headings;
		this.dragging = false;

		this.createListItems();
		this.activeItemListener();
		this.scrollHandler();

		if(_.clickEvent() === 'touchend') {
			this.bodyDraggingListener();
		}
	}

	createListItems() {
		/**
		 * We will get all "section > h2" on passed as an array when this class is initialized. For each of those
		 * h2's we want to create a quicknav item so we can click on them to scroll to the section. When created, append them
		 * to the quick nav unordered list and set a click event listener to scroll to the chosen section.
		 */
		this.items.forEach((item, index) => {
			item.setAttribute('data-index', index + 1);
			let listItem = document.createElement('LI');
			listItem.innerText = item.innerText;
			listItem.setAttribute('data-index', index + 1);
			this.container.appendChild(listItem);
		
			this.setListener(listItem);
		});
	}

	setListener(listItem) {
		listItem.addEventListener(_.clickEvent(), (e) => {

			if(_.clickEvent() === 'touchend') {
				if(!this.dragging && e.cancelable) {
					e.preventDefault();
					const index = e.target.getAttribute('data-index');
					const target = `h2[data-index="${index}"]`;
					_.scrollTo(target, 600)
				}
			} else {
				const index = e.target.getAttribute('data-index');
				const target = `h2[data-index="${index}"]`;
				_.scrollTo(target, 600);
			}
		})
	}

	activeItemListener() {
		/**
		 * Since all quicknav items have been created, select them all, along with the headings. After that, set a scroll listener to give and remove the active
		 * class based on the scroll position on the page.
		 */
		this.items = _.toArray(this.container.querySelectorAll('li'));
		this.headings = _.toArray(document.querySelectorAll('h2[data-index]'));
		window.addEventListener('scroll', _.debounce(this.scrollHandler.bind(this), 50));

		this.scrollHandler()
	}

	calcTopPosition( elem )
	{
		var offset = 0;
		
		do 
		{
			if ( !isNaN( elem.offsetTop ) )
			{
				offset += elem.offsetTop;
			}
		} while( ( elem = elem.offsetParent ) )

		return offset
	
	}

	scrollHandler() {
		
		// offset scroll position for reading position
		let offset = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) 
			offset = offset ? offset * 0.75 : 0

		let currentScrollPosition = window.pageYOffset + offset;
		var active = this.items[0].getAttribute('data-index')
		
		this.headings.forEach((heading) => {
			if( currentScrollPosition > this.calcTopPosition( heading ) ) {
				active = heading.getAttribute('data-index')
			}
		})

		this.items.forEach((element) => {
			if( element.getAttribute('data-index') == active ) {
				element.classList.add('active');
			}
			else {
				element.classList.remove('active');
			}
		})
	}

	bodyDraggingListener() {
		document.body.addEventListener('touchmove', function() {
			this.dragging = true;
		}.bind(this), false)

		document.body.addEventListener('touchstart', function() {
			this.dragging = false;
		}.bind(this), false)
	}
}